// Компоненты
import {CreativeCoalition} from "../../general_components/CreativeCoalition";

// Стили
import "./style/shop.scss";

export function ShopPage() {
    return (
        <div className="max_size">
            <CreativeCoalition>
                Всегда готова принять<br/>
                от вас заказ и сделать<br/>
                великолепие
            </CreativeCoalition>
            <form>
                <input
                    name="nickname"
                    type="text"
                    placeholder="Никнейм"
                    autoComplete="nickname"
                />
                <input
                    name="order"
                    type="text"
                    placeholder="Что вы хотите заказать"
                    autoComplete="order"
                />
                <textarea
                    name="preferences"
                    placeholder="Ваши предпочтения для заказа"
                    autoComplete="preferences"
                />
                <input
                    name="budget"
                    type="number"
                    placeholder="Какой у вас бюджет (в алмазах)"
                    autoComplete="budget"
                />
                <div className="office">
                    <input
                        name="office"
                        type="checkbox"
                        autoComplete="office"
                        className="input"
                    />
                    <p className="input center_text">
                        Готовы ли вы прийти за заказом в офис?
                    </p>
                </div>
                <button type="submit">Отправить</button>
            </form>
            <div className="line"/>
        </div>
    )
}